import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './wallet/appkit'
import WalletProviders from './wallet/WalletProviders'
import { SessionProvider } from './app/SessionContext'
import App from './app/App'

// Preserve the production cascade: launch + market surface first, consolidated live shell last.
import './styles/launch.css'
import './styles/marketplace-base.css'
import './styles/marketplace.css'
import './styles/swap-status.css'
import './styles/app.css'
import './styles/unified.css'

const root=document.getElementById('root')
if(!root) throw new Error('OnlyRose root element is missing')
createRoot(root).render(<React.StrictMode><WalletProviders><BrowserRouter><SessionProvider><App/></SessionProvider></BrowserRouter></WalletProviders></React.StrictMode>)
